import React from 'react';
import {Link} from 'react-router-dom';
import {Trans} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {nextStep} from '../../../components/tutorial/reducer';

export default function NextPageButton({link, id}) {
  const dispatch = useDispatch();
  return (
    <Link
      className="tutorial-tooltip-footer_next"
      to={link}
      onClick={() => {
        dispatch(nextStep());
      }}
      id={id}
    >
      <Trans i18nKey="tutorials.tooltip.next">Next</Trans>
    </Link>
  );
}
